/* TÖSTI: navy -> brun #2f231b, sand -> #F7F2E3, grå -> sand. Cookie-banner (shadow DOM) og Klaviyo-popups. Tilføjet fil.
   19-10-2026 (hastighed): Samme farveregler som før, men filen gennemgår ikke længere hele siden hvert sekund.
   - Cookie-banner og Klaviyo-popups farves, når de dukker op (og igen, hvis indholdet i dem skifter).
   - "Grå -> sand" på store flader køres i små bidder, når browseren har tid (efter indlæsning + 4 sek. senere).
   PageSpeed målte den gamle version til 1,4 sek. CPU + 1 sek. tvungen layoutberegning. */
(function () {
  'use strict';
  var BROWN = 'rgb(47, 35, 27)';
  var SAND = 'rgb(247, 242, 227)';
  var SEL = 'csm-cookie-consent, .needsclick, [class*="klaviyo"], [id*="klaviyo"]';

  function parse(v) {
    var m = v && v.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?/);
    if (!m) return null;
    return { r: +m[1], g: +m[2], b: +m[3], a: m[4] === undefined ? 1 : +m[4] };
  }
  function kind(v) {
    var c = parse(v);
    if (!c || c.a < 0.05) return null;
    if (c.b > c.r + 15 && c.b >= c.g - 5 && c.b < 200 && c.r < 120) return 'brown';
    if (c.r === 75 && c.g === 61 && c.b === 42) return 'brown';
    if (c.r >= 228 && c.g >= 215 && c.b >= 165 && c.r - c.b >= 24 && c.r - c.b <= 100) return 'sand';
    return null;
  }

  /* Først læses alle farver, derefter skrives alt på én gang (undgår gentagen layoutberegning) */
  var writes = [];
  function flush() {
    for (var i = 0; i < writes.length; i++) writes[i][0].style.setProperty(writes[i][1], writes[i][2], 'important');
    writes = [];
  }
  function paint(e, prop, v) {
    var k = kind(v);
    if (k) writes.push([e, prop, k === 'brown' ? BROWN : SAND]);
  }
  function fixEl(e) {
    try {
      var c = getComputedStyle(e);
      paint(e, 'background-color', c.backgroundColor);
      paint(e, 'color', c.color);
      ['Top', 'Right', 'Bottom', 'Left'].forEach(function (s) {
        if (c['border' + s + 'Width'] !== '0px') paint(e, 'border-' + s.toLowerCase() + '-color', c['border' + s + 'Color']);
      });
    } catch (x) {}
  }
  function fixTree(root) {
    if (root.nodeType === 1) fixEl(root);
    var l = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < l.length; i++) fixEl(l[i]);
  }

  /* ---------- Cookie-banner + Klaviyo: kun når de findes ---------- */
  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;
  var queue = [], qTimer = null;
  function enqueue(el) {
    if (queue.indexOf(el) === -1) queue.push(el);
    if (!qTimer) qTimer = setTimeout(runQueue, 150);
  }
  function watchRoot(root) {
    if (!watched || watched.has(root)) return;
    watched.add(root);
    var t = null;
    /* Skifter indholdet i popup'en (fx trin 2 i en Klaviyo-formular), farves kun den popup igen */
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { fixTree(root); flush(); }, 150);
    }).observe(root, { childList: true, subtree: true });
  }
  function handle(el) {
    if (!el.isConnected) return;
    if (el.tagName === 'CSM-COOKIE-CONSENT') {
      if (el.shadowRoot) { fixTree(el.shadowRoot); watchRoot(el.shadowRoot); }
      else if (!el.__tostiRetry || el.__tostiRetry < 10) {
        el.__tostiRetry = (el.__tostiRetry || 0) + 1;
        setTimeout(function () { enqueue(el); }, 500);
      }
      return;
    }
    fixTree(el);
    watchRoot(el);
  }
  function runQueue() {
    qTimer = null;
    var q = queue; queue = [];
    /* Kun de yderste elementer (indre elementer farves sammen med deres popup) */
    var roots = q.filter(function (el) {
      if (el === document.body || el === document.documentElement) return false;
      for (var i = 0; i < q.length; i++) if (q[i] !== el && q[i].contains && q[i].contains(el)) return false;
      return true;
    });
    roots.forEach(handle);
    flush();
  }
  function collect(node) {
    if (node.nodeType !== 1) return;
    if (node.matches && node.matches(SEL)) { enqueue(node); return; }
    if (node.querySelectorAll) {
      var l = node.querySelectorAll(SEL);
      for (var i = 0; i < l.length; i++) enqueue(l[i]);
    }
  }

  /* ---------- Grå -> sand på store flader, i små bidder ---------- */
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(function () { fn({ timeRemaining: function () { return 8; } }); }, 50); };
  function greyToSand() {
    var l = document.querySelectorAll('section, div, article'), i = 0, hits = [];
    function step(deadline) {
      var stop = i + 150;
      while (i < l.length && i < stop && (!deadline || deadline.timeRemaining() > 2)) {
        var e = l[i++];
        var c = parse(getComputedStyle(e).backgroundColor);
        if (!c || c.a < 0.9) continue;
        if (c.r >= 236 && c.r <= 250 && Math.abs(c.r - c.g) < 4 && Math.abs(c.g - c.b) < 4) hits.push(e);
      }
      if (i < l.length) { idle(step); return; }
      /* Størrelsen tjekkes kun for de få grå flader, til sidst */
      hits.forEach(function (e) {
        var r = e.getBoundingClientRect();
        if (r.width > 300 && r.height > 100) writes.push([e, 'background-color', SAND]);
      });
      flush();
    }
    idle(step);
  }

  function updSwipers() {
    var c = document.querySelectorAll('.swiper-container');
    for (var i = 0; i < c.length; i++) {
      if (c[i].swiper && c[i].swiper.update) c[i].swiper.update();
    }
  }

  function start() {
    collect(document.body);
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var a = list[i].addedNodes;
        for (var j = 0; j < a.length; j++) collect(a[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', function () {
    updSwipers();
    setTimeout(updSwipers, 800);
    greyToSand();
    setTimeout(greyToSand, 4000);
  });
})();
